import {
  Pagination,
  PaginationContent,
  PaginationEllipsis,
  PaginationItem,
  PaginationLink,
} from '@/components/ui/pagination';
import { cn } from '@/lib/utils';
import { ChevronLeft, ChevronRight } from 'lucide-react';

type PaginationProductReviewProps = {
  page: number;
  handlePageChange: (newPage: number) => void;
  totalPages: number;
};

export function PaginationProductReview({
  page,
  handlePageChange,
  totalPages,
}: PaginationProductReviewProps) {
  const renderPageNumbers = () => {
    const pageNumbers = [];

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      pageNumbers.push(1);

      if (page > 3) pageNumbers.push('ellipsis-start');

      const start = Math.max(2, page - 1);
      const end = Math.min(totalPages - 1, page + 1);
      for (let i = start; i <= end; i++) {
        pageNumbers.push(i);
      }

      if (page < totalPages - 2) pageNumbers.push('ellipsis-end');

      pageNumbers.push(totalPages);
    }

    return pageNumbers;
  };

  return (
    <Pagination className='mt-8'>
      <PaginationContent>
        {page !== 1 && (
          <PaginationItem>
            <PaginationLink
              href='#'
              onClick={(e) => {
                e.preventDefault();
                handlePageChange(page - 1);
              }}
              className='hover:bg-transparent'
            >
              <ChevronLeft className='h-4 w-4 hover:scale-105' />
            </PaginationLink>
          </PaginationItem>
        )}

        {renderPageNumbers().map((pageNum, index) =>
          pageNum === 'ellipsis-start' || pageNum === 'ellipsis-end' ? (
            <PaginationEllipsis key={`ellipsis-${index}`} />
          ) : (
            <PaginationItem key={pageNum}>
              <PaginationLink
                href='#'
                onClick={(e) => {
                  e.preventDefault();
                  handlePageChange(pageNum as number);
                }}
                isActive={page === pageNum}
                className={cn(
                  'relative items-center justify-center border-0 underline-offset-4 shadow-none ring-0 hover:bg-transparent hover:underline',
                  page === pageNum && 'underline underline-offset-4'
                )}
              >
                {pageNum}
              </PaginationLink>
            </PaginationItem>
          )
        )}

        {page !== totalPages && (
          <PaginationItem>
            <PaginationLink
              href='#'
              onClick={(e) => {
                e.preventDefault();
                handlePageChange(page + 1);
              }}
              className='hover:cursor-pointer hover:bg-transparent'
            >
              <ChevronRight className='h-4 w-4 hover:scale-105' />
            </PaginationLink>
          </PaginationItem>
        )}
      </PaginationContent>
    </Pagination>
  );
}
